import React, { useState, useEffect } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import Dashboard from '../../../../../layouts/Dashboard';

import CreateEmergencyRole from '../../../../../components/Global/EmergencyRoles/Create';

import { emergencyRoleInitQuery, Organisation } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
}

const CreateEmergencyRoleAdmin = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id } = useParams<UrlParams>();

  const [organisation, setOrganisation] = useState<Organisation>({
    name: '',
    emergencies: [],
  });

  const { data: emergencyRoleInitData } = useQuery(emergencyRoleInitQuery(organisation_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && emergencyRoleInitData) {
      setOrganisation(emergencyRoleInitData.organisations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [emergencyRoleInitData]);

  const handleFinish = (id: string) => {
    history.push(`/admin/trusts/${organisation_id}/emergency_roles`);
  };

  return (
    <>
      <Dashboard
        breadcrumbs={[
          { label: 'Trusts', link: '/admin/trusts' },
          { label: organisation.name, link: `/admin/trusts/${organisation_id}` },
          { label: 'Emergency roles', link: `/admin/trusts/${organisation_id}/emergency_roles` },
          { label: 'Create' },
        ]}>
        <CreateEmergencyRole organisation_id={organisation_id} emergencies={organisation.emergencies} handleFinish={handleFinish} />
      </Dashboard>
    </>
  );
};

export default withRouter(withStyles(styles)(CreateEmergencyRoleAdmin));
